import {createQueryKeys} from "../shared/query/query-keys";

export const userAccessKeys = createQueryKeys("user-access");
export const roleKeys = createQueryKeys("access-administration-roles");
export const permissionKeys = createQueryKeys("access-administration-permissions");

export const accessAdministrationMutationKeys = {
  createRole: ["access-administration", "mutation", "create-role"] as const,
  assignPermissionToRole: [
    "access-administration",
    "mutation",
    "assign-permission-to-role",
  ] as const,
  removePermissionFromRole: [
    "access-administration",
    "mutation",
    "remove-permission-from-role",
  ] as const,
  assignUserRole: ["access-administration", "mutation", "assign-user-role"] as const,
  removeUserRole: ["access-administration", "mutation", "remove-user-role"] as const,
  setPermissionOverride: ["access-administration", "mutation", "set-permission-override"] as const,
  removePermissionOverride: [
    "access-administration",
    "mutation",
    "remove-permission-override",
  ] as const,
};
